import React, {useState} from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import {  Pagination, Autoplay } from "swiper/modules";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import coverServe from '../Assets/Images/coverServe.jpg';
import coverWindow from '../Assets/Images/coverWindow.jpg';
import coveroffer from '../Assets/Images/coveroffer.jpg';
import { Typography, Button } from "@mui/material";
import { motion } from "framer-motion";
import planeTop from '../Assets/Images/coverPlaneTop2.jpg';




const slides = [
  {
    id: 1,
    // icon: <FaPlaneDeparture />,
    heading: "Every Journey Feels Like Home in the Sky",
    text: "At Shankh Air, empowering meaningful travel through thoughtful service and inspired connectivity",
    bg: planeTop,
    buttonText: "Book Now",
    buttonClass: "btn-book"
  },
  {
    id: 2,
    // icon: <FaSuitcaseRolling />,
    heading: "Book Your Journey with Ease",
    text: "Start your journey right with quick, reliable, and smart booking tools",
    bg: coverWindow,
    buttonText: "Read More",
    buttonClass: "btn-journey"
  },
  {
    id: 3,
    // icon: <FaMapMarkedAlt />,
    heading: "Enjoy discounts on domestic flights",
    text: "Discover breathtaking destinations across the country with unbeatable offers. From serene hill stations to vibrant cities, book your journey more affordable and memorable.",    
    bg: coveroffer,
    buttonText: "View Destinations",
    buttonClass: "btn-explore"
  },
  {
    id: 4,
    // icon: <FaRegSmileBeam />,
    heading: "Your Comfort, Our Priority",
    text: "Customer satisfaction with every flight. Shankh Air removes barriers so even first-time flyers can travel comfortably",
    bg: coverServe,
    buttonText: "Contact Us",
    buttonClass: "btn-contact"
  }
];

const SliderHome = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <Swiper
      onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
      modules={[Pagination, Autoplay]}
      navigation={false}
      pagination={{ clickable: true }}
      autoplay={{ delay: 2000 }}
      speed={1000} 
      // autoplay={false}
      loop={true}
      className="homeSwiper"
    >
        {slides.map((slide, index) => (
          <SwiperSlide key={slide.id}>
            <div
              className="slideContent"
              style={{ backgroundImage: `url(${slide.bg})` }}
            >
              {activeIndex === index && (
                <motion.div
                  className="overlayBox"
                  initial={{ y: 100, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 1.2, ease: "easeOut" }}
                >
                  {/* <Typography variant="h1" component="b" className="testShankh">Shankh air</Typography> */}
                  <Typography variant="h1">{slide.heading}</Typography>
                  <Typography variant="body1" component="p">
                    {slide.text}
                  </Typography>
                  <motion.div
                   className="btnWrapper sliderBtn"
                   initial={{ y: 120, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.9, ease: "easeOut" }}
                   >
                    <Button
                      variant="link"
                      className="coverBtn bg-orange btnIcon D-font"
                      style={{fontSize: '16px'}}
                    >
                      {slide.buttonText}
                    </Button>
                  </motion.div>
                </motion.div>
              )}
            </div>
          </SwiperSlide>
        ))}

    </Swiper>
  );
};

export default SliderHome;
